import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'dmmp-website-article-banner',
  templateUrl: './website-article-banner.component.html'
})
export class WebsiteArticleBannerComponent {

  @Input() identifier
  @Input() data
  @Input() module
  @Output() page = new EventEmitter()

}
